import HeaderContentsWithNoNavigation from '../../components/organism/headers/HeaderContentsWithNoNavigation.vue'
export default {
  components: { HeaderContentsWithNoNavigation }
}
